/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "ca-central-1",
    "aws_cognito_identity_pool_id": "ca-central-1:92174804-d208-4068-be05-c8260ffea530",
    "aws_cognito_region": "ca-central-1",
    "aws_user_pools_id": "ca-central-1_hI6VracAV",
    "aws_user_pools_web_client_id": "426eqov3dnbbf9v9mlkjig04jl",
    "oauth": {
        "domain": "tbthc387242d-c387242d-bprod.auth.ca-central-1.amazoncognito.com",
        "scope": [
            "phone",
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "https://takebacktheheat.org/login/,https://takebacktheheat.org/login/",
        "redirectSignOut": "https://takebacktheheat.org/logout/",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_POOLS",
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OPTIONAL",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_appsync_graphqlEndpoint": "https://qrk2tutlircs3kjzrgfzkkezkm.appsync-api.ca-central-1.amazonaws.com/graphql",
    "aws_appsync_region": "ca-central-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_appsync_apiKey": "da2-zsscpnzskrgwdge7gcp7vaz3tu",
    "aws_user_files_s3_bucket": "tbthstoragebucket231001-bprod",
    "aws_user_files_s3_bucket_region": "ca-central-1"
};


export default awsmobile;
